
/**
 * Http工具类
 *
 * @author chenlongtao
 */
class HttpUtil {
  /**
   * 获取Post请求实体
   * @param uri uri信息
   * @param body 请求body参数信息
   */
  getPostRequest = (uri, body) => {
    // url
    const url = uri;
    // 定义请求头信息
    const headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    // headers.append('Content-Type', 'multipart/form-data; charset=UTF-8');
    // headers.append('Accept', 'application/json, text/javascript, */*; q=0.01');
    // headers.append('X-Requested-With','XMLHttpRequest');
   // headers.append('access_token', sessionStorage.getItem("access_token"));
    // 定义请求初始化信息
    const init = {
      method: 'POST',
      headers: headers,
      mode: 'cors',
      cache: 'default',
      body : body,
  };
    // 初始化请求实体
    const request = new Request(url, init);

    // 返回请求实体
    return request;
  }

  /**
   * 获取Get请求实体
   * @param uri uri信息
   */
  getGetRequest = (uri) => {
    // url
    const url = uri;
    // 定义请求头信息
    const headers = new Headers();
   // headers.append("access_token", sessionStorage.getItem("access_token"));

    // 定义请求初始化信息
    const init = {
      method: 'GET',
      headers: headers,
      mode: 'cors',
      cache: 'default'
    };

    // 初始化请求实体
    const request = new Request(url, init);

    // 返回请求实体
    return request;
  }
}

export default HttpUtil;


// WEBPACK FOOTER //
// ./src/tool/http.js